// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__AQ6Rg","faq__articles":"FAQ_faq__articles__O1R0z","faq__article":"FAQ_faq__article__CQhYz","faq__article--main":"FAQ_faq__article--main___mWyQ"};